<template>
  <div class="ai-settings-view pa-6" data-testid="ai-settings-view">
    <div class="ai-settings-view__page-header">
      <PageHeader
        title="AI Settings"
        :loading="headerLoading"
        @refresh="onRefresh"
      />
    </div>

    <div class="ai-settings-view__tabs d-flex align-end" data-testid="ai-settings-view__tabs">
      <button
        type="button"
        class="folder-tab"
        :class="{ active: activeTab === 0 }"
        data-testid="ai-settings-view__tab-features"
        @click="setActiveTab(0)"
      >
        AI
      </button>
      <button
        type="button"
        class="folder-tab"
        :class="{ active: activeTab === 1 }"
        data-testid="ai-settings-view__tab-context"
        @click="setActiveTab(1)"
      >
        Context Settings
      </button>
    </div>

    <v-card class="ai-settings-view__panel flex-card shadow-off" flat outlined>
      <v-card-text class="ai-settings-view__panel-body pa-4">
        <keep-alive>
          <AiFeaturesTab
            v-if="activeTab === 0"
            key="ai-features"
            ref="featuresTab"
          />
          <AiContextSettingsTab
            v-else
            key="ai-context"
            ref="contextTab"
          />
        </keep-alive>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import PageHeader from '@/modules/varianceanalysis/components/PageHeader.vue';
import AiFeaturesTab from './features/AiFeaturesTab.vue';
import AiContextSettingsTab from './context-settings/AiContextSettingsTab.vue';

export default {
  name: 'AiSettingsView',
  components: {
    PageHeader,
    AiFeaturesTab,
    AiContextSettingsTab,
  },
  data() {
    return {
      activeTab: 0,
      headerLoading: false,
    };
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    async onRefresh() {
      this.headerLoading = true;
      try {
        if (this.activeTab === 0 && this.$refs.featuresTab?.$refs?.table?.refreshData) {
          this.$refs.featuresTab.$refs.table.refreshData();
        } else if (this.activeTab === 1 && this.$refs.contextTab?.refresh) {
          await this.$refs.contextTab.refresh();
        }
      } finally {
        this.headerLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AiSettingsView.scss';
</style>
